import { Endpoint, RecordsForPage } from "../mb_constants";

/**
 * 
 * @param {*} page 
 * @param {*} search 
 * @returns 
 */
const MbApi_DeviceList = async (page, search) => {
    
    try{
        const response = await fetch(
            `${Endpoint}/api/mb/v1/device/list?page=${page}&record_for_page=${RecordsForPage}${search ? `&search=${search}` : ''}`,
            {
                headers: {
                    'jwt': `Bearer ${localStorage.getItem('jwt')}`
                }
            }
        );

        if(response.status == 200){
            const data = await response.json();
            return data;
        }
    }catch(_){
        
    }

    return null;
};

/**
 * 
 * @param {*} code 
 * @returns 
 */
const MbApi_DeviceGetByCode = async (code) => {
    
    try{
        const response = await fetch(
            `${Endpoint}/api/mb/v1/device/get_by_code?code=${code}`,
            {
                headers: {
                    'jwt': `Bearer ${localStorage.getItem('jwt')}`
                }
            }
        );

        if(response.status == 200){
            const data = await response.json();
            return data;
        }
    }catch(_){
        
    }

    return null;
};


/**
 * 
 * @param {*} body 
 * @returns 
 */
const MbApi_DeviceCreate = async (body) => {

    const response = await fetch(
        `${Endpoint}/api/mb/v1/device/create`,
        {
            method: "POST",
            headers: {
                'jwt': `Bearer ${localStorage.getItem('jwt')}`,
                'Content-Type': "application/json"
            },
            body: body
        }
    );

    try{
        if(response.status == 201){
            const res = await response.json();
            if(res.Result == "OK"){
                return true;
            }
        }
    }catch(_){

    }

    return false;
};

/**
 * 
 * @param {*} id_device
 * @returns 
 */
const MbApi_DeviceDelete = async (id_device) => {

    const response = await fetch(
        `${Endpoint}/api/mb/v1/device/delete?id_device=${id_device}`,
        {
            method: "DELETE",
            headers: {
                'jwt': `Bearer ${localStorage.getItem('jwt')}`,
                'Content-Type': "application/json"
            }
        }
    );

    try{
        if(response.status == 200){
            const res = await response.json();
            if(res.Result == "OK"){
                return true;
            }
        }
    }catch(_){

    }

    return false;

};

export {
    MbApi_DeviceList,
    MbApi_DeviceCreate,
    MbApi_DeviceDelete,
    MbApi_DeviceGetByCode
}